module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av718-2b163a5e64f81465b95335a0a14f84d6.jpg";